import { Component, OnDestroy } from '@angular/core';

import { ReplaySubject } from 'rxjs';

import { getTranslation, SharedLanguageService } from '@language';
import { BaseFieldDefinition } from '../../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { SimpleFieldValue } from '../../../../entities/field-values/field-type-values.entity';
import { GenericTypedValue } from '../../../../entities/field-values/generic-typed-value.entity';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { VisibleProfileFieldChildren } from '../../../../helpers/visible-profile-field-children.helper';
import { ShSearchRoutingService } from '../../../../services/search-routing.service';
import { ShComplexReadonlyFieldComponent } from '../complex-readonly-field/complex-readonly-field.component';

@Component({
    selector: 'sh-multi-item-readonly-field',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    templateUrl: './multi-item-readonly-field.component.html'
})
export class ShMultiItemReadonlyFieldComponent extends ShComplexReadonlyFieldComponent implements OnDestroy {
    public typeTranslations!: Map<string, string>;
    public typeFieldDefinitions!: Map<string, BaseFieldDefinition>;

    public typedValues$: ReplaySubject<GenericTypedValue<SimpleFieldValue[]>[]> = new ReplaySubject<
        GenericTypedValue<SimpleFieldValue[]>[]
    >(1);

    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: ShSearchRoutingService,
        protected translateService: SharedLanguageService
    ) {
        super(fieldHelper, searchRoutingService);
    }

    init(profileField: ExtendedBaseProfileField, record: PartialRecord): void {
        this.typeTranslations = new Map();
        this.typeFieldDefinitions = new Map();

        VisibleProfileFieldChildren(profileField).forEach(child => {
            const overrideTranslation: string | null = getTranslation(this.translateService, child.DottedKey);
            const translation: string = overrideTranslation ? overrideTranslation : (child.Label ?? '');
            this.typeTranslations.set(child.Key, translation);
            this.typeFieldDefinitions.set(child.Key, child);
        });

        this.typedValues$.next(this.fieldHelper.getMultiItemFieldValue(profileField.FieldDefinition, record));
    }

    protected isNotNullOrUndefined<T>(input: null | undefined | T): input is T {
        return input != null;
    }

    public ngOnDestroy(): void {
        this.typedValues$.complete();
        super.ngOnDestroy();
    }
}
